import { defineComponent as r, createElementBlock as a, openBlock as i, createVNode as o, unref as e, withCtx as t, createElementVNode as l, normalizeClass as d, renderSlot as s } from "vue";
import { Disclosure as u, DisclosureButton as f, DisclosurePanel as m } from "@headlessui/vue";
import { ScalarIconCaretRight as _ } from "@scalar/icons";
const p = { class: "section-accordion-wrapper" }, h = { class: "section-accordion-title" }, k = /* @__PURE__ */ r({
  __name: "SectionContainerAccordion",
  setup(v) {
    return (c, C) => (i(), a("div", p, [
      o(e(u), {
        as: "div",
        class: "section-accordion",
        defaultOpen: ""
      }, {
        default: t(({ open: n }) => [
          o(e(f), { class: "section-accordion-button" }, {
            default: t(() => [
              o(e(_), {
                class: d(["section-accordion-chevron size-5 transition-transform", { "rotate-90": n }])
              }, null, 8, ["class"]),
              l("div", h, [
                s(c.$slots, "title", {}, void 0, !0)
              ])
            ]),
            _: 2
          }, 1024),
          o(e(m), { class: "section-accordion-content" }, {
            default: t(() => [
              s(c.$slots, "default", {}, void 0, !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]));
  }
});
export {
  k as default
};
